/**
 * The server entry must never import this folder: it would drag React into the server
 * build. From the client, import only `@gsf/kit`; take game types from `@gsf/games`, not
 * `../state.js`, or a second copy of the Zod schemas lands in the bundle.
 */

import type { GameUi } from '@gsf/kit';
import { JeopardyDisplay } from './display';
import { JeopardyHost } from './host';
import { JeopardyPlayer } from './player';

export const jeopardyUi: GameUi = {
  host: JeopardyHost,
  display: JeopardyDisplay,
  player: JeopardyPlayer,
};

export { JeopardyDisplay, JeopardyHost, JeopardyPlayer };
export { audienceKind, clueIsSpent, jeopardyView, type JeopardyView } from './view';
